import { Component, Input } from '@angular/core';
import { listActionStyles, ListProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-list-actions',
  template: `
    <div [ngClass]="listActionStyles">
      <ng-content></ng-content>
    </div>
  `,
})
export class ListActionsComponent {
  /**
   * Tamaño del list: sm o extra small
   */
  @Input() size: ListProps['size'];
  /**
   * CSS del componente
   */
  @Input() css: ListProps['css'];

  public get listActionStyles(): string[] {
    return [listActionStyles().className];
  }
}
